import { Routes } from '@angular/router';
import { BookClaimComponent } from './features/book-claim/book-claim.component';
import { ClaimsFormComponent } from './features/book-claim/components/claims-form/claims-form.component';
import { ConfirmationComponent } from './features/confirmation/confirmation.component';
import { DemoComponent } from './features/demo/demo.component';
import { EngineerTrackingComponent } from './features/engineer-tracking/engineer-tracking.component';
import { MmrComponent } from './features/mmr/mmr.component';
import { OrbitConfirmationComponent } from './features/orbit/book-claim/components/orbit-claims-form/components/orbit-confirmation/orbit-confirmation.component';
import { ProductTypeComponent } from './features/orbit/book-claim/components/orbit-claims-form/components/product-type/product-type.component';
import { SmartFixComponent } from './features/orbit/book-claim/components/orbit-claims-form/components/smart-fix-gen-ai/smart-fix.component';
import { OrbitClaimsFormComponent } from './features/orbit/book-claim/components/orbit-claims-form/orbit-claims-form.component';
import { OrbitClaimComponent } from './features/orbit/book-claim/orbit-claim.component';
import { ErrorPageComponent } from './features/orbit/error-page/error-page.component';
import { NoEngineerAvailableComponent } from './features/orbit/error-page/no-engineer-available/no-engineer-available.component';
import { ServiceNotDueComponent } from './features/orbit/error-page/service-not-due/service-not-due.component';
import { RebookingComponent } from './features/orbit/rebooking/rebook/rebooking.component';
import { RebookingConfirmationComponent } from './features/orbit/rebooking/rebooking-confirmation/rebooking-confirmation.component';
import { AppInfo } from './global/environment';
import { orbitStepGuard } from './shared/guards/orbit-step.guard';
import { userAuthGuard } from './shared/guards/user-auth.guard';

export const routes: Routes = [
  // A route for demonstrating how to use features or components within the app
  {
    path: 'demo',
    loadComponent: () => DemoComponent,
    canActivate: [
      () => {
        return AppInfo.Environment.localDevelopment ?? false;
      },
    ],
  },
  {
    path: 'my-plans/:planNumber/claims/:claimId/rebook',
    canActivate: [userAuthGuard],
    loadComponent: () => RebookingComponent,
    data: { title: 'Rebooking' },
  },
  {
    path: 'my-plans/:planNumber/claims/:claimId/rebooking-confirmation',
    canActivate: [userAuthGuard],
    loadComponent: () => RebookingConfirmationComponent,
    data: { title: 'Rebooking confirmation' },
  },
  {
    path: 'my-plans/:planNumber',
    children: [
      {
        path: 'claims',
        loadComponent: () => MmrComponent,
        data: {
          title: 'Manage my repairs',
        },
        children: [
          {
            path: ':claimId',
            children: [
              {
                path: 'track',
                data: {
                  title: 'Track your repair',
                },
                loadComponent: () => EngineerTrackingComponent,
              },
              {
                path: '',
                pathMatch: 'full',
                redirectTo: (route) => {
                  return `my-plans/${route.params['planNumber']}/claims`;
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'my-plans/:planNumber/claims/:claimId/rebook',
    canActivate: [userAuthGuard],
    loadComponent: () => RebookingComponent,
    data: { title: 'Rebooking' },
  },
  {
    path: 'my-plans/:planNumber/claims/:claimId/rebooking-confirmation',
    canActivate: [userAuthGuard],
    loadComponent: () => RebookingConfirmationComponent,
    data: { title: 'Rebooking confirmation' },
  },
  {
    path: ':planNumber',
    canActivate: [userAuthGuard],
    children: [
      {
        path: 'orbit/error',
        loadComponent: () => ErrorPageComponent,
        data: {
          title: 'Error',
        },
      },
      {
        path: 'orbit/no-engineer',
        loadComponent: () => NoEngineerAvailableComponent,
        data: {
          title: 'No Engineer Available',
        },
      },
      {
        path: 'orbit/service-not-due',
        loadComponent: () => ServiceNotDueComponent,
        data: {
          title: 'Service Not Due',
        },
      },
      {
        // Used this way to break smart fix out of the form style
        path: 'orbit/smart-fix',
        loadComponent: () => SmartFixComponent,
        data: {
          title: 'Smart Fix',
        },
        canActivate: [orbitStepGuard],
      },
      {
        // Used this way to break smart fix out of the form style
        path: 'orbit/product-type',
        loadComponent: () => ProductTypeComponent,
        data: {
          title: 'Product Type',
        },
        canActivate: [orbitStepGuard],
      },
      {
        path: 'orbit/confirmation',
        loadComponent: () => OrbitConfirmationComponent,
        data: {
          title: 'Confirmation',
        },
      },
      {
        path: 'orbit',
        loadComponent: () => OrbitClaimComponent,
        children: [
          {
            path: ':step',
            loadComponent: () => OrbitClaimsFormComponent,
            canActivate: [orbitStepGuard],
          },
        ],
      },
      {
        path: 'book-claim',
        loadComponent: () => BookClaimComponent,
        data: {
          title: 'Book your claims',
        },
        children: [
          {
            path: ':step',
            loadComponent: () => ClaimsFormComponent,
          },
        ],
      },
      {
        path: 'confirmation',
        loadComponent: () => ConfirmationComponent,
        data: {
          title: 'Confirmation',
        },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'claims',
      },
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: () => {
      // document.location.href = AppInfo.Environment.myAccountURL + '/my-plans';
      return '';
    },
  },
];
